export const PRESET_2_WEEKS = '2w';
export const PRESET_4_WEEKS = '4w';
export const PRESET_6_WEEKS = '6w';
export const PRESET_8_WEEKS = '8w';
export const FETCH_SHOP_RETENTION = 'FETCH_SHOP_RETENTION';
